import React from 'react';
import { Section } from './Section';
import { Star } from 'lucide-react';
const reviews = [{
  quote: 'La uso todas las noches.',
  detail: 'Ideal para no despertar a mi pareja. La luz es súper cómoda.',
  name: 'Martín G.',
  location: 'Buenos Aires'
}, {
  quote: 'La batería dura muchísimo.',
  detail: 'La cargué hace dos semanas y la sigo usando todos los días.',
  name: 'Sofía L.',
  location: 'Córdoba'
}, {
  quote: 'Perfecta para leer sin molestar.',
  detail: 'El brazo flexible es clave para apuntar justo al libro.',
  name: 'Diego R.',
  location: 'Rosario'
}, {
  quote: 'Súper liviana y cómoda.',
  detail: 'Me la llevo a los viajes, no ocupa nada de espacio.',
  name: 'Carolina M.',
  location: 'Mendoza'
}];
export function Reviews() {
  return <Section className="border-t border-black/5" data-id="element-158">
      <div className="mb-16 text-center max-w-2xl mx-auto" data-id="element-159">
        <p className="text-sm font-medium text-[#FF6B1A] tracking-widest uppercase mb-4" data-id="element-160">
          Reseñas reales
        </p>
        <h2 className="text-3xl md:text-5xl font-light tracking-tight text-balance" data-id="element-161">
          Lo que dicen quienes ya la usan
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-162">
        {reviews.map((review, i) => <div key={i} className="p-8 rounded-3xl bg-white border border-black/5 hover:border-[#FF6B1A]/30 hover:shadow-xl hover:shadow-[#FF6B1A]/5 transition-all duration-500 flex flex-col h-full" data-id="element-163">
            <div className="flex gap-0.5 mb-6 text-[#FF6B1A]" data-id="element-164">
              {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" strokeWidth={0} data-id="element-165" />)}
            </div>
            <h4 className="text-xl font-semibold mb-3 leading-snug" data-id="element-166">
              "{review.quote}"
            </h4>
            <p className="text-[#6B6B6B] font-light text-sm mb-8 flex-grow" data-id="element-167">
              {review.detail}
            </p>
            <div data-id="element-168">
              <p className="text-sm font-semibold text-[#0A0A0A]" data-id="element-169">
                {review.name}
              </p>
              <p className="text-xs text-[#6B6B6B] font-light mt-0.5" data-id="element-170">
                {review.location}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}